module.exports = __webpack_public_path__ + "img/Formosa 1867_3.21902610.jpg";